import * as React from "react";
import { useState, useContext } from "react";
import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";
import AuthenticationDomain from "domainActions/authentication/AuthenticationDomain";
import { FormikInput, Spinner } from "components/common";
import { Button, Row, Col } from "components/bootstrap";
import ConnectionErrors, { NotificationContainer } from "./ConnectionErrors";
import BackendWizardContext from "./BackendWizardContext";
const UserLoginTest = ({ prepareSubmitPayload }) => {
  const { authBackendMeta } = useContext(BackendWizardContext);
  const { t } = useTranslation("authentication");
  const initialLoginStatus = {
    loading: false,
    success: false,
    testFinished: false,
    result: void 0,
    message: void 0,
    errors: []
  };
  const [{ loading, testFinished, success, message, errors, result }, setLoginStatus] = useState(initialLoginStatus);
  const hasErrors = errors && errors.length >= 1;
  const _handleLoginTest = ({ username, password }) => {
    setLoginStatus({ ...initialLoginStatus, loading: true });
    return AuthenticationDomain.testLogin({
      backend_configuration: prepareSubmitPayload(void 0),
      user_login: { username, password },
      backend_id: authBackendMeta.backendId
    }).then((response) => {
      setLoginStatus({
        loading: false,
        testFinished: true,
        message: response.message,
        result: response.result,
        errors: response.errors,
        success: response.success
      });
    }).catch((error) => {
      var _a, _b;
      const requestErrors = [error == null ? void 0 : error.message, (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.res) == null ? void 0 : _b.text];
      setLoginStatus({
        loading: false,
        success: false,
        testFinished: true,
        result: void 0,
        message: void 0,
        errors: requestErrors
      });
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("login_test.description")), /* @__PURE__ */ React.createElement(Formik, { onSubmit: _handleLoginTest, initialValues: { password: "", username: "" } }, /* @__PURE__ */ React.createElement(Form, { className: "form" }, /* @__PURE__ */ React.createElement(Row, { className: "no-bm" }, /* @__PURE__ */ React.createElement(Col, { sm: 6 }, /* @__PURE__ */ React.createElement(FormikInput, { label: t("login_test.username"), name: "username", id: "user-login-username", required: true })), /* @__PURE__ */ React.createElement(Col, { sm: 6 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: t("login_test.password"),
      name: "password",
      type: "password",
      id: "user-login-password",
      required: true
    }
  ))), /* @__PURE__ */ React.createElement(Button, { type: "submit" }, loading ? /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: t("login_test.submit") }) : t("login_test.submit")), !hasErrors && testFinished && /* @__PURE__ */ React.createElement(NotificationContainer, { bsStyle: success ? "success" : "danger" }, /* @__PURE__ */ React.createElement("b", null, !(result == null ? void 0 : result.user_exists) && t("login_test.user_does_not_exist"), (result == null ? void 0 : result.user_exists) && /* @__PURE__ */ React.createElement(React.Fragment, null, (result == null ? void 0 : result.login_success) ? message : t("login_test.login_failed"))), (result == null ? void 0 : result.user_exists) && (result == null ? void 0 : result.user_details) && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("table", { className: "table" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("login_test.user_attribute")), /* @__PURE__ */ React.createElement("th", null, t("login_test.value")))), /* @__PURE__ */ React.createElement("tbody", null, Object.entries(result == null ? void 0 : result.user_details).map(([key, value]) => /* @__PURE__ */ React.createElement("tr", { key }, /* @__PURE__ */ React.createElement("td", null, String(key)), /* @__PURE__ */ React.createElement("td", null, String(value)))))))), hasErrors && /* @__PURE__ */ React.createElement(ConnectionErrors, { errors, message }))));
};
export default UserLoginTest;
